import React, { useState } from "react";
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';
import "./UnitFilters.css";

const UnitFilters = ({ onFilterChange }) => {
  const [filters, setFilters] = useState({
    unitType: "",
    unitStatus: "",
    minPrice: "",
    maxPrice: "",
    minBUA: "",
    maxBUA: "",
    minBedrooms: "",
    maxBedrooms: "",
    buildingNumber: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedFilters = { ...filters, [name]: value };
    setFilters(updatedFilters);
    onFilterChange(updatedFilters);
  };

  const handleReset = () => {
    const resetFilters = {
      unitType: "",
      unitStatus: "",
      minPrice: "",
      maxPrice: "",
      minBUA: "",
      maxBUA: "",
      minBedrooms: "",
      maxBedrooms: "",
      buildingNumber: "",
    };
    setFilters(resetFilters);
    onFilterChange(resetFilters);
  };

  return (
    <div className="unit-filters-container">
      <Card className="filters-card">
        <Card.Body>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Unit Type</Form.Label>
                <Form.Select
                  name="unitType"
                  value={filters.unitType}
                  onChange={handleChange}
                >
                  <option value="">All Types</option>
                  <option value="Office">Office</option>
                  <option value="Clinic">Clinic</option>
                  <option value="Shop">Shop</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="unitStatus"
                  value={filters.unitStatus}
                  onChange={handleChange}
                >
                  <option value="">All Statuses</option>
                  <option value="Available">Available</option>
                  <option value="Reserved">Reserved</option>
                  <option value="Sold">Sold</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>Building Number</Form.Label>
                <Form.Control
                  type="text"
                  name="buildingNumber"
                  value={filters.buildingNumber}
                  onChange={handleChange}
                  placeholder="Building #"
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>Min Price</Form.Label>
                <Form.Control
                  type="number"
                  name="minPrice"
                  value={filters.minPrice}
                  onChange={handleChange}
                  placeholder="Min Price"
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>Max Price</Form.Label>
                <Form.Control
                  type="number"
                  name="maxPrice"
                  value={filters.maxPrice}
                  onChange={handleChange}
                  placeholder="Max Price"
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>Min BUA (m²)</Form.Label>
                <Form.Control
                  type="number"
                  name="minBUA"
                  value={filters.minBUA}
                  onChange={handleChange}
                  placeholder="Min BUA"
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>Max BUA (m²)</Form.Label>
                <Form.Control
                  type="number"
                  name="maxBUA"
                  value={filters.maxBUA}
                  onChange={handleChange}
                  placeholder="Max BUA"
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="filter-actions mt-3">
            <Button 
              variant="primary" 
              onClick={() => onFilterChange(filters)}
              className="filter-btn"
            >
              <FaFilter /> Apply Filters
            </Button>
            <Button 
              variant="outline-secondary" 
              onClick={handleReset}
              className="reset-btn"
            >
              Reset Filters
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default UnitFilters; 